import React from "react";
import { Cell } from "react-table";
import { BaseTooltip } from "src/components";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import ContractStatusChip from "src/components/contract/ContractStatusChip";
import ProductTypeChangeLabel from "src/components/ProductTypeChangeLabel";
import { getContractDetailPath } from "src/utils/route-util";

export const ContractListColumns = [
  {
    Header: "신청번호",
    accessor: "contractApplyNumber",
    width: 120,
    Cell: (props: Cell<any>) => {
      const contractId = props.row.original.contractId;
      return <BaseNewTabLink path={getContractDetailPath({ contractId })} value={props.value} className="w-100" />;
    },
  },
  {
    Header: "상태",
    accessor: "contractStep",
    width: 80,
    Cell: (props: Cell<any>) => <ContractStatusChip status={props.value} />,
  },

  {
    Header: "계약명",
    accessor: "contractName",
    width: 200,
    Cell: (props: Cell<any>) => (
      <div className="w-100">
        <BaseTooltip contents={props.value ? props.value : "-"}></BaseTooltip>
      </div>
    ),
  },
  {
    Header: "상품명",
    accessor: "spaceProductName",
    width: 220,
    Cell: (props: Cell<any>) => (
      <div className="w-100">
        <BaseTooltip contents={props.value ? props.value : "-"}></BaseTooltip>
      </div>
    ),
  },
  {
    Header: "상품유형",
    accessor: "spaceProductType",
    width: 80,
    Cell: (props: Cell<any>) => <ProductTypeChangeLabel productType={props.value} />,
  },
  {
    Header: "법인명/상호",
    accessor: "mbOrganizationName",
    width: 180,
    Cell: (props: Cell<any>) => (
      <div className="w-100">
        <BaseTooltip contents={props.value ? props.value : "-"}></BaseTooltip>
      </div>
    ),
  },
];

export default ContractListColumns;
